import { render, staticRenderFns } from "./QuestionPage.vue?vue&type=template&id=2528cf30&scoped=true"
import script from "./QuestionPage.vue?vue&type=script&lang=js"
export * from "./QuestionPage.vue?vue&type=script&lang=js"
import style0 from "./QuestionPage.vue?vue&type=style&index=0&id=2528cf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528cf30",
  null
  
)

export default component.exports